import React from 'react';
import moment from 'moment';

import './FeedbackHistory.css';

const FeedbackHistory = (props) => {
  return (
    <div className="evaluation-history-container">
      {(props.feedbackHistory.length > 0) ? 
        props.feedbackHistory.map((feedbackItem) => 
          <div className="evaluation-history-content">
            <div className="processed-content">
              <span className="processed-icon">
                <div className={ feedbackItem.status.toLowerCase() + "-icon"}></div>
              </span>
              <div className="processed-user">
                <span className="processed-user-label">
                  {(feedbackItem.status) === "PROGRESS" ? "Progressed by:" : "Regretted by:" }
                </span>
                <span className="processed-user-name">
                  {feedbackItem.username}
                </span>
              </div>
              <div className="processed-date-time">
                {moment(feedbackItem.datetime).format("dddd, D MMMM | h:mma")}
              </div>
            </div>
            {(feedbackItem.feedback) ? 
              <div className="evaluation-data">
                <div className="evaluation-data-label">Evaluation:</div>
                <div className="evaluation-data-content">
                  {feedbackItem.feedback}
                </div>
              </div>
              : null 
            }
          </div>
        )
      : null }    
    </div>
  )
}

export default FeedbackHistory;


// WEBPACK FOOTER //
// ./src/components/Common/FeedbackHistory/FeedbackHistory.js